import { Shell } from './components/Shell';

export default function App() {
  return <Shell />;
}
